import { render, staticRenderFns } from "./livepicform.vue?vue&type=template&id=1a06dbf8&scoped=true&"
import script from "./livepicform.vue?vue&type=script&lang=js&"
export * from "./livepicform.vue?vue&type=script&lang=js&"
import style0 from "./livepicform.vue?vue&type=style&index=0&id=1a06dbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a06dbf8",
  null
  
)

export default component.exports